export default __webpack_public_path__ + "static/media/transfer.60a93a42.svg";